module.exports = __webpack_public_path__ + "static/img/empty.3269961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/action/empty.png
// module id = mPVk
// module chunks = 1